import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class StringValidator {

  public static url(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let validUrl = true;
      if (control.value) {
        const url = control.value.startsWith('http') ? control.value : 'http://' + control.value;
        try {
          const urlObject = new URL(url);
          control.setValue(urlObject.toString(), {emitEvent: false});
        } catch {
          validUrl = false;
        }
      }
      return validUrl ? null : { InvalidUrl: true };
    };
  }

}
